/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by Terraform. It will be overwritten.

const awsmobile = {
  aws_project_region: "eu-central-1",
  aws_cognito_identity_pool_id: "eu-central-1:b8cef50c-7816-4d65-b7e7-947f92dd0a2a",
  aws_cognito_region: "eu-central-1",
  aws_user_pools_id: "eu-central-1_qWLM0y67O",
  aws_user_pools_web_client_id: "3i4t27cng6ro2go7muj9d5jr2e",
  oauth: {
    domain: "login.app.cleverday.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "cleverdaymobile://oauth2.redirect/,https://portal.app.cleverday.com/oauth2/redirect/,https://redirect.app.cleverday.com/oauth2/redirect/",
    redirectSignOut: "cleverdaymobile://oauth2.redirect/,https://portal.app.cleverday.com/oauth2/redirect/,https://redirect.app.cleverday.com/oauth2/redirect/",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
};

export default awsmobile;

